module.exports = __webpack_public_path__ + "static/img/hw4.b088c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/hw/hw4.png
// module id = ZlfB
// module chunks = 0